import type { Settings } from "../types";

export function vehicleAdvertUrl(vehicleId: string, language: Settings["language"] = "pt") {
  const path = language === "de" ? "/cars" : `/${language}/cars`;
  const url = new URL(path, "https://www.precisionautotechnik.com");
  url.searchParams.set("country", "CH");
  url.searchParams.set("vehicle", vehicleId);
  return url.toString();
}
